import { Outlet, Route } from "react-router";
import ErrorBoundaryEmptyState from "@Core/components/emptyStates/Error503/ErrorBoundaryEmptyState";
import BetaLockRoute from "@routes/BetaLockRoute";
import ErrorBoundaryRoute from "@routes/ErrorBoundaryRoute/ErrorBoundaryRoute";
import {
  DIETITIAN_ROLES,
  protectedLoader,
  revalidateOnPathChange,
} from "@routes/protectedLoader";
import { Roles } from "@utils/settings";
import {
  SALES_PRODUCT,
  SALES_PRODUCT_NEW,
  SALES_PRODUCTS,
  SALES_STOREFRONT,
} from "@routes/routes";
import {
  DashboardLayout,
  SalesProductEditorPage,
  SalesProductsPage,
  SalesStorefrontPage,
} from "@routes/lazyPages";

export const salesRoutes = (
  <>
    <Route
      loader={protectedLoader([Roles.DIETITIAN_OWNER])}
      shouldRevalidate={revalidateOnPathChange}
      element={
        <ErrorBoundaryRoute>
          <Outlet />
        </ErrorBoundaryRoute>
      }
      errorElement={<ErrorBoundaryEmptyState />}
    >
      <Route lazy={DashboardLayout}>
        <Route element={<BetaLockRoute />}>
          <Route path={SALES_PRODUCTS} lazy={SalesProductsPage} />
          <Route path={SALES_PRODUCT_NEW} lazy={SalesProductEditorPage} />
          <Route path={SALES_PRODUCT} lazy={SalesProductEditorPage} />
        </Route>
      </Route>
    </Route>
    <Route
      loader={protectedLoader(DIETITIAN_ROLES)}
      shouldRevalidate={revalidateOnPathChange}
      element={
        <ErrorBoundaryRoute>
          <Outlet />
        </ErrorBoundaryRoute>
      }
      errorElement={<ErrorBoundaryEmptyState />}
    >
      <Route lazy={DashboardLayout}>
        <Route element={<BetaLockRoute />}>
          <Route path={SALES_STOREFRONT} lazy={SalesStorefrontPage} />
        </Route>
      </Route>
    </Route>
  </>
);
